'use client';

import { useEffect, useState } from 'react';
import { buildLoyaltyApplePassUrl } from '@/lib/wallet-pass';

// An effect rather than a useMemo because the URL depends on
// window.location.host: computing it inline renders a different value on the
// server than the client and trips a hydration mismatch.
export function useLoyaltyApplePassUrl(token: string | null): string {
  const [url, setUrl] = useState('');

  useEffect(() => {
    setUrl(token ? buildLoyaltyApplePassUrl(token, window.location.host) : '');
  }, [token]);

  return url;
}
